// extracted by mini-css-extract-plugin
export var customBullet = "Carousel-module__customBullet--2ES2t";
export var customBulletActive = "Carousel-module__customBulletActive--2kpo6";
export var customBulletActiveBrand = "Carousel-module__customBulletActiveBrand--31O6s";
export var customBulletBrighter = "Carousel-module__customBulletBrighter--3qVKu Carousel-module__customBullet--2ES2t";
export var customBulletContainer = "Carousel-module__customBulletContainer--18yze";
export var textWithImageContainer = "Carousel-module__textWithImageContainer--2p6nF";
export var titleContainer = "Carousel-module__titleContainer--Jo0_0";
export var withBackground = "Carousel-module__withBackground--2z_pu";
export var withoutBackground = "Carousel-module__withoutBackground--1jwks";